module.exports = __webpack_public_path__ + "media/images/webpage/instagram/index-top-thumb-0467e2720491007ae75d97b4dd04f05e.webp";